import React from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';
import EditMenuPage from '../pages/EditMenuPage/EditMenuPage';

const ManageRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path="/manage">
        <Redirect to="/manage/place" />
      </Route>
      <Route path={path} component={EditMenuPage} />
    </Switch>
  );
};

export default ManageRoutes;
